import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import Request from 'frontools/data/Request';
import { RequestConfig, RequestEvent, RequestMethod } from 'frontools/data/Request';
import { autobind } from 'frontools/decorators/Autobind';
import { Overlay, OverlayOptions } from './Overlay';
import Breakpoint from 'frontools/core/Breakpoint';

declare var dataLayer;

export class FilterNav extends AbstractDispatcher {

    public static CHANGE            : string                        = 'change';

    private _isMobile               : boolean                       = Breakpoint.isLowerThan(Breakpoint.TABLET);

    private _overlay                : Overlay;
    private _overlayOptions         : OverlayOptions                = new OverlayOptions();

    private _elButtons              : NodeListOf<HTMLElement>;
    private _elLinks                : NodeListOf<HTMLElement>;
    private _elOverlayElements      : NodeListOf<HTMLElement>;
    private _requestConfig          : RequestConfig                 = new RequestConfig();
    private _elContentDiv           : HTMLElement                   = document.createElement('div');

    private _elActiveLink           : HTMLElement;
    private _nextLinkSelector       : string;
    private _activeUrl              : string;

    private _scrollTop              : number;

    constructor(private _el : HTMLElement) {
        super();

        this._elActiveLink = this._el.querySelector('a.active, button.active') as HTMLElement;
        this._nextLinkSelector = this._elActiveLink.getAttribute('data-filter-button');

        this._elButtons = this._el.querySelectorAll('[data-filter-button]') as NodeListOf<HTMLElement>;
        for (var index = 0; index < this._elButtons.length; index++) {
            this._elButtons[index].addEventListener('click', this._onCategoryClick);
        }

        var specialityLink = this._el.querySelector('[data-filter-list=""]');
        specialityLink.addEventListener('click', function(e) {
            if (Breakpoint.isLowerThan(Breakpoint.TABLET)) {
                e.preventDefault();
                return;
            }
            this._scrollTop = document.body.scrollTop;
            this._nextLinkSelector = specialityLink.getAttribute('data-filter-button');
            this._onLinkClick(e);
        }.bind(this));   

        // Initial push state
        var stateObj = new StateObj(window.location.href, (this._elActiveLink.querySelector('.name') as HTMLElement).innerText,  this._nextLinkSelector)
        history.replaceState(stateObj, window.location.href, window.location.href); 
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
        this._activeUrl = window.location.href;

        window.onpopstate = this._onPopState.bind(this);
    }

    @autobind
    private _onCategoryClick(e) {
        var list;
        e.target.classList.add('active');
        this._scrollTop = document.body.scrollTop;
        this._nextLinkSelector = e.currentTarget.getAttribute('data-filter-button');
        if (!Breakpoint.isLowerThan(Breakpoint.TABLET) && this._nextLinkSelector) list = this._el.querySelector('[data-filter-list='+this._nextLinkSelector+']') as HTMLElement;
        else list = this._el.querySelector('[data-filter-lists]') as HTMLElement;
        if (list) {
            var listClone = list.cloneNode(true) as HTMLElement;
            this._elLinks = listClone.querySelectorAll('a') as NodeListOf<HTMLAnchorElement>;
            this._elOverlayElements = listClone.querySelectorAll('h2, a') as NodeListOf<HTMLElement>;
            TweenMax.set( this._elOverlayElements, {opacity:0, y: -50, display:'block'});
            for (var index = 0; index < this._elLinks.length; index++) {
                this._elLinks[index].addEventListener('click', this._onLinkClick)
            }   
            this._overlayOptions.customClasses = "menu_nav";
            this._overlayOptions.wrapperCustomClasses = "menu";
            this._overlay = new Overlay(listClone, this._overlayOptions);
            this._overlay.addListener(Overlay.OPEN, function() {
                TweenMax.staggerTo(this._elOverlayElements, 0.05, {opacity: 1, y:0, ease: Expo.easeOut}, 0.01);          
            }.bind(this))
        }           
    }

    @autobind
    private _onLinkClick(e) {
        e.preventDefault();
        var url = e.currentTarget.href as string;   
        if (this._activeUrl == url) {
            if (this._overlay) this._overlay.close();
            return;
        }
        this._activeUrl = url;
        var stateObj = new StateObj(url, e.currentTarget.innerText, this._nextLinkSelector);
        history.pushState(stateObj, url, url);
        this._executeRoute(stateObj); 

        var data = e.currentTarget.getAttribute('data-tracking');
        if (data) data = data.split('|');
        else data= ['accueil','filtre','le-meilleur-de-shoot']
        dataLayer.push({eventCategory: data[0], eventAction: data[1], eventLabel: data[2], event: 'genericGAEvent'});
    }

    private _executeRoute(state: StateObj) {
        this._requestConfig.url = state.url as string;
        let request = new Request(this._requestConfig);
        request.addListener(RequestEvent.LOAD, this._onRequestLoad);
        if (this._overlay && this._overlay.isOpen) {
            // TweenMax.staggerTo(this._elOverlayElements, 0.2, {opacity: 0, y:-50, ease: Expo.easeOut}, 0.1, function() {
                this._overlay.close();
            // }.bind(this)
            // );  
        } else {
            document.body.scrollTop = this._scrollTop;      // In case history scroll restauration manual is not working (Overlay will scroll to the right position anyway)
        }
        this._changeActiveLink(state.nextLink, state.nextText);
    }

    @autobind
    private _onPopState(e) {
        if (!e.state) return;
        this._executeRoute(e.state);
    }

    @autobind
    private _onRequestLoad(e) {
        this._elContentDiv.innerHTML = e.response;
        document.title = this._elContentDiv.querySelector('title').innerText
        var content = this._elContentDiv.querySelector('[data-grid]');
        this.dispatch({type: FilterNav.CHANGE, content: content});
    }

    private _changeActiveLink(nextLink: string, filterText: string) {
        if (this._elActiveLink) {
            this._elActiveLink.classList.remove('active');
            (this._elActiveLink.querySelector('.name') as HTMLElement).innerText = this._elActiveLink.getAttribute('data-unselected');
        }
        var elNextLink = this._el.querySelector('[data-filter-button='+nextLink+']') as HTMLElement;
        if (filterText) (elNextLink.querySelector('.name') as HTMLElement).innerText = filterText;
        elNextLink.classList.add('active');
        this._elActiveLink = elNextLink;
    }

    public get overlay () : Overlay {
        return this._overlay;
    }

}

class StateObj {
    constructor(public url:string, public nextText:string, public nextLink:string) {
    }
}